export const attendance = {
  table: {
    date: 'Date',
    total: 'Total',
    inquiry: 'Inquiry',
    export: 'Export',
    id: 'ID',
    fullName: 'Name',
    contactHours: 'Contact hours',
    workingTime: 'Working time',
    addTabs: 'Additional tabs',
    name: 'Name',
    process: 'Process',
    inOut: 'IN or OUT',
    time: 'Time',
    addEmployee: 'Add employee',
    create: 'Create Attendance',
    update: 'Update or Delete attendance',
    delete: 'Delete attendance',
    save: 'Save',
    totalError: 'Total Error',
  },
  pageHeader: {
    title: 'Data correction, error checking',
    titleError: 'Error checking',
  },
  filter: {
    filterDay: 'View by date',
    filterEmployee: 'Filter by employee',
    error: 'Error specification',
    false: 'Specified',
    true: 'Unspecified',
    defaultValue: 'No data',
    specified: 'Specified',
    dateError: '',
    gender: 'gender',
    position: 'position',
    department: 'department',
  },
}
